// Source data: https://docs.google.com/spreadsheets/d/1JfLXWV401imxhR-eTzF2k3C_3xL3O6RyX3k-bKH5DPg/edit#gid=0
export type subCategoryType = {
  label: string
  value: string
}
type category = {
  label: string
  value?: string
  subcategories: Array<subCategoryType>
}
interface categoryHierarchyType {
  [key: string]: category
}

export const CATEGORY_HIERARCHY_MAP: categoryHierarchyType = {
  insurance: {
    label: 'Insurance',
    value: '4052b9fe-f246-11e3-ae32-22000b2985d5',
    subcategories: [],
  },
  businessServices: {
    label: 'Business Services',
    subcategories: [
      { value: '9f15f07b-e93d-42eb-8ac0-f1c459ecd8b8', label: 'Advertising' },
      {
        value: '810132a8-f2fa-4489-8f61-2519b0253de3',
        label: 'Appliance | Furniture | Equipment Rental and Leasing',
      },
      {
        value: 'df6d3828-58ca-4906-bdc7-bd11db88a5aa',
        label: 'Commercial Graphics | Art | Photography',
      },
      {
        value: '715b99b6-7e39-4144-bff1-7f27ca8bf5f9',
        label: 'Computer Maintenance and Repair',
      },
      {
        value: 'fe151010-f975-4e33-8b7b-ccdcc0f61e6d',
        label: 'Computer Programming | Data Processing',
      },
      {
        value: '58f2c551-1aa6-40e5-a92b-94be9debcac6',
        label: 'Copy and Reproduction',
      },
      {
        value: '1509612e-b0d2-4406-aff1-a9c1e5113846',
        label: 'Credit Reporting',
      },
      {
        value: 'b328e98c-f164-42f1-8efa-a6f9dcefe13d',
        label: 'Employment Agency',
      },
      {
        value: '31fb9bec-9b91-11e9-9737-0025902ddc28',
        label: 'Franchise Fees | Purchase of a Business',
      },
      {
        value: '59fb4ceb-88d4-498c-9698-4db566d62fd3',
        label: 'Information Retrieval',
      },
      {
        value: 'c68ec953-8ff7-44a7-8960-879a364aa69a',
        label: 'Labor | Payroll',
      },
      {
        value: '19527bf7-8edb-4115-a13c-251856b3b1db',
        label: 'Management | Consulting | Public Relations Services',
      },
      {
        value: 'e6f0aa50-3586-486b-9f16-885225706fed',
        label: 'Miscellaneous Repair Services',
      },
      {
        value: '5d533cb8-07da-49f0-887a-130aa55e7bee',
        label: 'Office Supplies',
      },
      {
        value: 'b04e86ba-f685-4ea8-bc6c-92a9a42c048c',
        label: 'Photo Finishing',
      },
      {
        value: '9b756dfb-ae0c-44a1-bdda-591dfb0adcc1',
        label: 'Publishing | Printing',
      },
      {
        value: 'e51ec524-d095-48e2-9d7c-9e67e56be328',
        label: 'Security | Investigative Services',
      },
      {
        value: '42f259bc-5726-11e5-98cf-22000b2985d5',
        label: 'Shipping | Hauling | Freight | Moving',
      },
      {
        value: 'd7c35527-87ec-47b8-b6a0-26293a9e8ec4',
        label: 'Stenography & Secretarial Support',
      },
      {
        value: '778f75ae-eabe-4021-9a71-fa1b3355c1cd',
        label: 'Video and Film Production and Distribution',
      },
      {
        value: '4052bf80-f246-11e3-ae32-22000b2985d5',
        label: 'Other Business Services',
      },
    ],
  },
  constructionAndMaintenance: {
    label: 'Construction and Maintenance',
    subcategories: [
      {
        value: '8f0db9e0-9988-4869-8660-601000847f4b',
        label: 'Architecture and Engineering',
      },
      { value: '2c115a86-4d30-4d69-937d-9aab07d68a1d', label: 'Carpentry' },
      {
        value: '07e63450-6509-4905-8577-d5ea1a34d99a',
        label: 'Cleaning | Janitorial',
      },
      { value: '1b9964be-f886-49b7-bada-af310d6ffd8a', label: 'Concrete Work' },
      {
        value: '737f6fe4-7642-4984-9ebb-3bd3546a3943',
        label: 'Electrical Contractor',
      },
      { value: '255f6c20-a435-4316-9e6d-f7f9440fa01a', label: 'Exterminating' },
      {
        value: '42f25944-5726-11e5-98cf-22000b2985d5',
        label: 'General Contractors | Builders',
      },
      {
        value: '459dfe66-a449-42b0-8066-6669e33d1f06',
        label: 'Glass| Paint | Wallpaper',
      },
      {
        value: 'd3645933-a6ed-4f16-9388-6ee0f1442b13',
        label: 'Heating | Plumbing | Air Conditioning | Irrigation',
      },
      {
        value: 'a16361da-b9a4-440c-9953-3b9bdb890ea1',
        label: 'Hydraulic Plumbing and Heating Equipment',
      },
      {
        value: 'd0f0ca51-0b2c-4292-811c-b55cf17c8e48',
        label: 'Landscaping | Gardening',
      },
      {
        value: '69ee94a9-9a55-468c-bdb3-b5ef3deeaf6c',
        label: 'Lumber and Building Materials - Wholesale',
      },
      {
        value: '3b85bad4-07ed-4630-8ff6-16190b959b8d',
        label: 'Masonry | Stonework | Tile Setting | Plastering | Insulation',
      },
      {
        value: 'e7174cec-c812-4d01-bb87-016378fa27be',
        label: 'Metal Products and Service',
      },
      {
        value: 'e6f0aa50-3586-486b-9f16-885225706fed',
        label: 'Miscellaneous Repair Services',
      },
      {
        value: 'b184d8c5-dcf2-4080-a39a-36701ffb2795',
        label: 'Other Construction Materials',
      },
      { value: '8eb7a320-8b51-43dd-bee5-2afd0ee193b8', label: 'Paint' },
      {
        value: '6ed19e6c-7490-49ae-b686-7546c5af89d0',
        label: 'Roofing | Siding | Sheet Metal',
      },
      { value: '8a79809c-794b-46df-8a42-d27b6306d4bc', label: 'Welding' },
      {
        value: 'b2fc2a18-404e-4334-8c29-a6b4b038f602',
        label: 'Other Contracting Services incl Painting',
      },
    ],
  },
  educationAndChildcare: {
    label: 'Education and Child Care',
    subcategories: [
      {
        value: 'a3e0f589-db41-4c44-949d-2dd1c490c481',
        label: 'Business | Secretarial Schools',
      },
      {
        value: 'fcc855d3-770c-4798-91b0-7761a19e6b70',
        label: 'Childcare Services | Daycare',
      },
      {
        value: '4052b3fa-f246-11e3-ae32-22000b2985d5',
        label: 'Colleges | Universities | Professional Schools',
      },
      {
        value: '858eaa05-79e7-4224-b840-08550eea33bf',
        label: 'Correspondence Schools',
      },
      {
        value: 'cf730b7f-c474-45e0-bdaa-2ca7d1b424ac',
        label: 'Dance Hall | Studios | Schools',
      },
      {
        value: 'bee16043-54e3-4e08-9575-5a0ad487c607',
        label: 'Elementary and Secondary Schools',
      },
      { value: '3127f53a-9b91-11e9-9737-0025902ddc28', label: 'Student Loans' },
      {
        value: '54bac59d-31aa-4b6b-a1ea-21abbc1e59bc',
        label: 'Trade and Vocational Schools',
      },
      {
        value: '8fd76827-c668-4d6b-b74c-560ba7458ccc',
        label: 'Other Schools & Educational Services',
      },
    ],
  },
  financialServicesAndLoans: {
    label: 'Financial Services and Loans',
    subcategories: [
      {
        value: '810132a8-f2fa-4489-8f61-2519b0253de3',
        label: 'Appliance | Furniture | Equipment Rental and Leasing',
      },
      {
        value: '6248739b-d714-4bcc-8000-000f289db158',
        label: 'Credit card payments',
      },
      {
        value: '08a14c2a-c4a2-42d5-a278-4f98cfe46ce1',
        label: 'Investments | Financial Services',
      },
      {
        value: '277b0964-9b91-11e9-9737-0025902ddc28',
        label: 'Mortgage | HELOC',
      },
      {
        value: '460a4b54-932f-4745-85ed-2ed2c2eabc78',
        label: 'Personal Loans',
      },
      { value: '3127f53a-9b91-11e9-9737-0025902ddc28', label: 'Student Loans' },
      {
        value: 'a7f61d1f-98a5-4ff2-b257-710cf89e27ce',
        label: 'Vehicle lease payments',
      },
      {
        value: '4052afc2-f246-11e3-ae32-22000b2985d5',
        label: 'Vehicle loan payments',
      },
    ],
  },
  wholesaleInventory: {
    label: 'Wholesale Inventory',
    subcategories: [
      {
        value: '5542c470-24eb-4558-ab7a-00d7ce8fc9bc',
        label: 'Auto Parts and Supplies',
      },
      {
        value: 'e3809a85-4f01-4ae3-8948-bb965f6c078f',
        label: 'Books | Newspapers',
      },
      { value: 'e48d6de3-7e4a-4af5-a8d3-97acc386933c', label: 'Chemicals' },
      {
        value: 'd31751ec-5f6b-4f1c-b227-b3b983264b9a',
        label: 'Cleaning Products',
      },
      {
        value: 'eb7f9f54-b024-423b-8834-2496899efb65',
        label: 'Commercial Footwear',
      },
      {
        value: '88571d37-7d12-440f-9f47-23d3bae634e2',
        label: 'Computer Hardware | Software | Equipment',
      },
      {
        value: '60d1a9a6-2d7b-44df-bc83-2aafb4758f4c',
        label: 'Cosmetics | Perfumes | Toiletries | Sundries',
      },
      { value: 'ebf7a18f-3dbe-40b5-94ed-220deb01ed3d', label: 'Durable Goods' },
      {
        value: '2c7919b7-b533-4bf5-a8f6-579b5dcf4099',
        label: 'Electrical Parts and Equipment',
      },
      {
        value: '1793c842-21e5-4632-ad33-e098b34a60f8',
        label: 'Florists Supplies',
      },
      {
        value: '29a3475c-11eb-493f-9d04-1ef85669bf6a',
        label: 'Food and Beverage',
      },
      {
        value: '9b5cb22b-dc4b-4c58-8756-f2068a85b2b1',
        label: 'Food Service and Commercial Equipment',
      },
      {
        value: '459dfe66-a449-42b0-8066-6669e33d1f06',
        label: 'Glass | Paint | Wallpaper',
      },
      { value: '524d184f-bc2f-4691-8e50-cda60ac400c0', label: 'Hardware' },
      {
        value: 'a16361da-b9a4-440c-9953-3b9bdb890ea1',
        label: 'Hydraulic Plumbing and Heating Equipment',
      },
      { value: '42f25958-5726-11e5-98cf-22000b2985d5', label: 'Industrial' },
      {
        value: '69ee94a9-9a55-468c-bdb3-b5ef3deeaf6c',
        label: 'Lumber | Building Materials',
      },
      {
        value: 'b61bbab1-668d-4705-ae65-efcb3b05985c',
        label: 'Medical Equipment and Supplies',
      },
      {
        value: '4ce218db-6c98-4bf8-a8ff-f14886140c5e',
        label: 'Office Equipment',
      },
      {
        value: '4a097c8a-b1a4-4109-bbb4-12cf1809320b',
        label: 'Office Furniture',
      },
      {
        value: '5d533cb8-07da-49f0-887a-130aa55e7bee',
        label: 'Office Supplies',
      },
      {
        value: 'b184d8c5-dcf2-4080-a39a-36701ffb2795',
        label: 'Other Construction Materials',
      },
      { value: '8eb7a320-8b51-43dd-bee5-2afd0ee193b8', label: 'Paint' },
      {
        value: '823db734-978a-4d8e-97c0-e2b89f8fbaa2',
        label: 'Petroleum Products - Wholesale',
      },
      {
        value: '70bc5207-3605-4179-a8da-0265c0e6602e',
        label: 'Piece Goods | Notions | Other Dry Goods',
      },
      {
        value: '6ed19e6c-7490-49ae-b686-7546c5af89d0',
        label: 'Roofing | Siding | Sheet Metal',
      },
      {
        value: 'b94dc4f5-1bd8-42f1-b601-d4b74f0e13cb',
        label: 'Telecom Equipment and Phones',
      },
      {
        value: '650720a1-7d75-4821-bdb3-58fe389b970f',
        label: 'Uniforms | Commercial Clothing',
      },
      {
        value: '42f259da-5726-11e5-98cf-22000b2985d5',
        label: 'Other Inventory or Nondurable Goods',
      },
    ],
  },
  governmentAndUtilities: {
    label: 'Government and Utilities',
    subcategories: [
      { value: '4d8957e9-2916-4c4c-bf3a-7b04448efe34', label: 'Court Costs' },
      {
        value: '72819af5-c565-4a41-93bf-9d5a255a333c',
        label: 'Government Fines',
      },
      {
        value: '18fe5ad8-3292-4d1d-8f9e-79868affaa4e',
        label: 'Government Service',
      },
      {
        value: '4052bd78-f246-11e3-ae32-22000b2985d5',
        label: 'Telecom | Internet | Cable',
      },
      { value: '4052bed6-f246-11e3-ae32-22000b2985d5', label: 'Utilities' },
    ],
  },
  personalServices: {
    label: 'Personal Services',
    subcategories: [
      { value: 'e361fe48-fb80-4191-a916-6b72f45c0933', label: 'Charities' },
      {
        value: 'fcc855d3-770c-4798-91b0-7761a19e6b70',
        label: 'Childcare Services and Daycare',
      },
      { value: '255f6c20-a435-4316-9e6d-f7f9440fa01a', label: 'Exterminating' },
      {
        value: '1223b83f-b1ca-427f-a989-00e124f1aa5c',
        label: 'Membership Organizations',
      },
      {
        value: 'e33c0c1c-9c37-4fe7-9bc8-2b48ad2a7139',
        label: 'Religious | Civic | Social or Political Organizations',
      },
      {
        value: '42f2598a-5726-11e5-98cf-22000b2985d5',
        label: 'Other Personal Services',
      },
    ],
  },
  professionalServices: {
    label: 'Professional Services',
    subcategories: [
      {
        value: '689b2fde-830c-4b33-ab73-e581e205cfbe',
        label: 'Accounting | Tax Services',
      },
      { value: '9f15f07b-e93d-42eb-8ac0-f1c459ecd8b8', label: 'Advertising' },
      {
        value: 'df6d3828-58ca-4906-bdc7-bd11db88a5aa',
        label: 'Commercial Graphics | Art | Photography',
      },
      {
        value: 'fe151010-f975-4e33-8b7b-ccdcc0f61e6d',
        label: 'Computer Programming | Data Processing',
      },
      {
        value: '7b51f344-28d1-4473-9f3f-e6e1ccfc70b7',
        label: 'Legal Services',
      },
      {
        value: '19527bf7-8edb-4115-a13c-251856b3b1db',
        label: 'Management | Consulting | Public Relations Services',
      },
      {
        value: '1223b83f-b1ca-427f-a989-00e124f1aa5c',
        label: 'Membership Organizations',
      },
      {
        value: '9b756dfb-ae0c-44a1-bdda-591dfb0adcc1',
        label: 'Publishing | Printing',
      },
      {
        value: '42ba27fe-b252-473b-b507-445fc0e256d4',
        label: 'Testing Laboratories',
      },
      {
        value: '778f75ae-eabe-4021-9a71-fa1b3355c1cd',
        label: 'Video and Film Production and Distribution',
      },
      {
        value: '4052b81e-f246-11e3-ae32-22000b2985d5',
        label: 'Other Professional Services',
      },
    ],
  },
  rentAndRealEstate: {
    label: 'Rent and Real Estate',
    subcategories: [
      {
        value: '319971b0-9b91-11e9-9737-0025902ddc28',
        label: 'Commercial Rent',
      },
      {
        value: '5349a8d2-15ce-4764-a741-5288f0f9c214',
        label: 'HOA | Condo Fees',
      },
      {
        value: '277b0964-9b91-11e9-9737-0025902ddc28',
        label: 'Mortgage | HELOC',
      },
      {
        value: '4052bc10-f246-11e3-ae32-22000b2985d5',
        label: 'Residential Rent',
      },
    ],
  },
  vehicleAndTransportation: {
    label: 'Vehicle and Transportation',
    subcategories: [
      {
        value: '5542c470-24eb-4558-ab7a-00d7ce8fc9bc',
        label: 'Auto Parts and Supplies',
      },
      {
        value: '42f259bc-5726-11e5-98cf-22000b2985d5',
        label: 'Shipping | Hauling | Freight | Moving',
      },
      {
        value: 'a7f61d1f-98a5-4ff2-b257-710cf89e27ce',
        label: 'Vehicle Lease Payments',
      },
      {
        value: '4052afc2-f246-11e3-ae32-22000b2985d5',
        label: 'Vehicle Loan Payments',
      },
      {
        value: 'a5a2b40f-3bb2-4e48-9c84-d09556daf48f',
        label: 'Vehicle Purchase - Airplane | ATV | Golf Carts',
      },
      {
        value: '06ca792e-7b39-4ef5-a267-c0c4b81d3142',
        label: 'Vehicle Purchase - Auto | Truck',
      },
      {
        value: '74e1d780-4f2f-448f-91d1-8246d37f1bb5',
        label: 'Vehicle Purchase - Boat  | RV | Motorcycle | Snowmobile',
      },
    ],
  },
}

export const getCategories = () =>
  Object.keys(CATEGORY_HIERARCHY_MAP).map(category => {
    const itemObject = {
      value: category,
      label: CATEGORY_HIERARCHY_MAP[category]?.label || '',
    }
    return itemObject
  })

export const getSubCategoriesFromCategory = (category?: string) => {
  if (category) {
    return CATEGORY_HIERARCHY_MAP[category]?.subcategories
  }
  return []
}
